import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { Button } from '@finect/tabular-core/Button';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Container, Icon } from './partials';
export var NoResultsPlaceholder = function NoResultsPlaceholder(props) {
  var link = props.link,
    text = props.text,
    IconComponent = props.icon;
  var linkProps = link.hasOwnProperty('data-fi-event') ? {
    'data-fi-event': link['data-fi-event']
  } : {};
  return React.createElement(Container, null, React.createElement(Icon, null, React.createElement(IconComponent, null)), React.createElement("div", null, React.createElement(Paragraph, null, text), React.createElement(AppLink, _extends({
    href: link.href,
    rel: "nofollow"
  }, linkProps), React.createElement(Button, {
    width: "auto"
  }, link.text))));
};